export const GET_FEED_OPTIONS_DATA = "GET_FEED_OPTIONS_DATA";
export const FEED_OPTIONS_DATA_LOADING = "FEED_OPTIONS_DATA_LOADING";
export const FEED_OPTIONS_DATA_ERROR = "FEED_OPTIONS_DATA_ERROR";
export const SET_FEED_OPTIONS_DATA = "SET_FEED_OPTIONS_DATA";

export const GET_ALL_FEEDS_DATA = "GET_ALL_FEEDS_DATA";
export const SET_ALL_FEEDS_DATA = "SET_ALL_FEEDS_DATA";
export const SET_ALL_FEEDS_DATA_LOADING = "SET_ALL_FEEDS_DATA_LOADING";
export const SET_IS_NEED_UPDATE_DATA = "SET_IS_NEED_UPDATE_DATA";
export const SET_ALL_FEEDS_DATA_ERROR = "SET_ALL_FEEDS_DATA_ERROR";
